/* eslint-disable react/prop-types */
import { MdDeleteForever } from "react-icons/md";
import Modal from "../../../../Components/Shared/Modal";
import ReactQuill from "react-quill";

const CreateModal = (props) => {
    const { isModal, setIsModal, isLoading, categories, description, setDescription,
        handleSubmit, register, links, handleRemoveFile, handleFileChange } = props;
    return (
        <Modal isOpen={isModal} onClose={() => setIsModal(false)}>
            <form onSubmit={handleSubmit} className="">
                <div className="form-control">
                    <label className="label">
                        <span className="label-text text-lg font-medium ">Title:</span>
                    </label>
                    <input
                        {...register("name", { required: true })}
                        type="text"
                        name="name"
                        placeholder="Post Title"
                        className="input input-bordered text-lg"
                        required
                    />
                </div>

                <div className="flex sm:flex-col md:flex-row justify-between gap-4">
                    <div className="form-control w-full">
                        <label className="label">
                            <span className="label-text text-lg font-medium ">
                                Category
                            </span>
                        </label>
                        <select
                            {...register("category", { required: true })}
                            name="category"
                            className="select select-bordered w-full  text-lg"
                        >
                            <option disabled selected>
                                Select category
                            </option>
                            {categories.map((c) => (
                                <option key={c._id} value={c.name}>
                                    {c.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="form-control">
                    <label className="label">
                        <span className="label-text text-lg font-medium ">
                            Images: *
                        </span>
                        <span className="label-text">
                            Max: upload 1 image
                        </span>
                    </label>
                    <input
                        type="file"
                        onChange={handleFileChange}
                        className="file-input file-input-bordered w-full max-w-xs text-lg"
                        multiple
                    />

                    <div className="avatar gap-2 mt-2">
                        {(links ?? []).map((link, index) => (
                            <div key={index} className="w-14 rounded">
                                <img src={link.url} alt={`file preview ${index}`} />
                                <span
                                    className="bottom-1 cursor-pointer absolute text-2xl text-red-600"
                                    onClick={() => handleRemoveFile(link.publicId)}
                                >
                                    <MdDeleteForever />
                                </span>
                            </div>
                        ))}
                        {isLoading && (
                            <span className="text-green-700 font-semibold">
                                Uploading...
                            </span>
                        )}
                    </div>
                </div>

                <div className="form-control w-full">
                    <label className="label">
                        <span className="label-text text-lg font-medium ">
                            Short Description <span className="text-red-500">*</span>
                        </span>
                    </label>
                    <textarea
                        {...register("short_description", { required: false })}
                        name="short_description"
                        className="textarea textarea-bordered textarea-lg px-2 py-0"
                        placeholder="Short Description"
                    ></textarea>
                </div>

                <div className="inline-block">
                    <label className="label">
                        <span className="label-text text-lg font-medium ">
                            Content <span className="text-red-500">*</span>
                        </span>
                    </label>
                    <ReactQuill
                        value={description}
                        onChange={(value) => setDescription(value)}
                        name="description"
                        modules={{
                            toolbar: {
                                container: [
                                    [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
                                    [{ size: [] }],
                                    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                    [{ list: 'ordered' }, { list: 'bullet' }],
                                    ['link'],
                                    ['clean'],
                                    ['code-block']
                                ]
                            }
                        }}
                        style={{ height: 250, maxHeight: 250 }}
                    />
                </div>

                <div className="mt-6 mx-auto">
                    <button
                        type="submit"
                        disabled={isLoading && true}
                        className="btn text-xl bg-mainColor"
                    >
                        Submit
                    </button>
                </div>
            </form>
        </Modal>
    )
}

export default CreateModal;